import {CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { DxListModule } from 'devextreme-angular';

import { BookmarkSideMenuComponent } from '../bookmark-side-menu/bookmark-side-menu.component';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { PanelBarModule } from '../common/panel-bar/panel-bar.module';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { LayoutComponent } from './layout-component/layout.component';
import { AppVersionBannerComponent } from '../common/components/app-version-banner/app-version-banner.component';
import { PhoenixCommonModule } from '../common/PhoenixCommon.module';
import { GlobalSearchBarModule } from '../global-search/global-search-bar/global-search-bar.module';
import { MiniNavigationComponent } from '../sidenav/components/mini-navigation/mini-navigation.component';
import { TodoListComponent } from '../sidenav/components/todo-list/todo-list.component';
import { TopNavMenuModule } from '../top-nav-menu/top-nav-menu.module';

const components = [
  HeaderComponent,
  SidenavComponent,
  BreadcrumbsComponent,
  LayoutComponent,
  BookmarkSideMenuComponent,
  TodoListComponent,
  MiniNavigationComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    PhoenixCommonModule,
    FormsModule,
    TopNavMenuModule,
    GlobalSearchBarModule,
    RouterModule,
    DxListModule,
    MatIconModule,
    MatTooltipModule,
    PanelBarModule,
    AppVersionBannerComponent
  ],
  exports: components
})
export class LayoutModule {
}
